import * as React from "react";
const SvgFiRrSnowplow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23.656 21.46a6.75 6.75 0 0 1-1.98-4.807V8.062a.985.985 0 1 0-1.971 0v3.94h-2.966v-.01a2.956 2.956 0 0 0-2.278-2.866L12.13 3.909C10.875.653 5.163-.148 4.927 4.113V6.09a3.94 3.94 0 0 0-3.941 3.941v.005l.006 4.912a4.958 4.958 0 0 0 3.935 7.89h7.881a4.957 4.957 0 0 0 3.941-7.88v-.986h2.956v2.68a8.7 8.7 0 0 0 2.561 6.197.985.985 0 1 0 1.39-1.39M7.882 3.127c1.057 0 2.016.621 2.449 1.586l1.937 4.335h-4.38a.985.985 0 0 1-.985-.985L6.897 4.11c0-.544.441-.985.985-.985M3.535 8.643a1.96 1.96 0 0 1 1.391-.581v.005a2.956 2.956 0 0 0 2.956 2.95h5.902c.541 0 .981.437.985.979v1.402a4.9 4.9 0 0 0-1.96-.41H4.926c-.676 0-1.344.138-1.963.408l-.008-3.364a1.95 1.95 0 0 1 .58-1.392zm9.273 12.226H4.927a2.956 2.956 0 1 1 0-5.91h7.881a2.956 2.956 0 1 1 0 5.91m-6.896-2.955a.985.985 0 1 1-1.97 0 .985.985 0 0 1 1.97 0m7.882 0a.985.985 0 1 1-1.97 0 .985.985 0 0 1 1.97 0m-3.941 0a.985.985 0 1 1-1.97 0 .985.985 0 0 1 1.97 0"
    />
  </svg>
);
export default SvgFiRrSnowplow;
